import React, {useCallback, useEffect, useState} from "react";
import {useFocusEffect} from "@react-navigation/native";
import {Ionicons} from "@expo/vector-icons";
import * as Progress from "react-native-progress";
import {Box, HStack, IconButton, Input, ScrollView, Text, VStack,} from "native-base";
import {useTheme} from "./context/ThemeProvider";
import {collection, getDocs} from "firebase/firestore";
import {auth, db} from "../backend/database/Firebase";
import QuickInputWords from "./components/QuickInputWords";
import {useRegisterAndStoreToken} from "../backend/notifications/RegisterAndStoreToken";
import {useLocalNotifications} from "../backend/notifications/useLocalNotifications";
import {checkAndUpdateStreak} from "../backend/streaks/CheckAndUpdateStreak";
import FeedbackButton from "./components/FeedbackButton";
import {LevelProgress} from "./StreaksAndLevelProgress/LevelProgress";
import {StreakDisplay} from "./StreaksAndLevelProgress/StreakDisplay";
import {Platform} from "react-native";
import SettingsButton from "./components/SettingsButton";
import {useToast} from "react-native-toast-notifications";

import MixpanelService from "../backend/API/Mixpanel";

export default function HomeScreen({navigation}) {
    const [queryText, setQueryText] = useState("");
    const [randomInputs, setRandomInputs] = useState([]);
    const {theme, themes} = useTheme();
    const colors = themes[theme];
    const [userCred, setUserCred] = useState(null);
    const toast = useToast();

    // if (Platform.OS === "android") {
    //     const {
    //     scheduleInactivityReminder,
    //     } = useLocalNotifications();
    // }
    const [streakData, setStreakData] = useState({isNewStreak: false, streakCount: 0});

    // useEffect(() => {
    //     const updateStreak = async () => {
    //         try {
    //             const result = await checkAndUpdateStreak();
    //             setStreakData(result);
    //             console.log("isNewStreak: ", streakData.isNewStreak);
    //
    //             if (streakData.isNewStreak && streakData.streakCount > 1) {
    //                 console.log("Toast for streaks is working")
    //                 toast.show(`New Streak achieved of "${streakData.streakCount} days! Congratulations!"`, {
    //                     type: 'success',
    //                     placement: 'top',
    //                     duration: 5000,
    //                     animationType: 'slide-in',
    //                 });
    //
    //             }
    //         } catch (error) {
    //             console.error("Error updating streak:", error);
    //         }
    //     };
    //
    //     updateStreak();
    // }, []);
    useEffect(() => {
        const initializeMixpanel = async () => {
            try {
                await MixpanelService.initialize();
                MixpanelService.track("Logged In");
                MixpanelService.flush();
            } catch (error) {
                console.error("Mixpanel initialization error:", error);
            }
        };

        initializeMixpanel();
    }, []);

    useEffect(() => {
        const currentUser = auth.currentUser;
        if (currentUser) {
            // Create a structure similar to UserCredential
            setUserCred({
                user: currentUser
            });
            console.log("Current user set in HomeScreen:", currentUser.uid);
        }
    }, []);

    if (Platform.OS === "android") {
        // Register push token when user is available
        const token = useRegisterAndStoreToken(userCred);
        // Log when token is successfully registered
        useEffect(() => {
            if (token && userCred) {
                console.log("Token registered in HomeScreen:", token.data);
            }
        }, [token, userCred]);
    }


    useFocusEffect(
        React.useCallback(() => {
            console.log("HomeScreen is focused, setting up inactivity reminder");

                // scheduleInactivityReminder(3600); // 1 hour
            return () => {
                console.log("HomeScreen is unfocused, cleaning up");
                // TODO Maybe remove pending notifications
            };
        }, [])
    );

    useEffect(() => {
        return auth.onAuthStateChanged((user) => {
            if (user) {
                // User is authenticated, set up custom header
                navigation.setOptions({
                    headerLeft: () => <StreakDisplay/>,
                    headerTitle: () => <LevelProgress/>,
                    headerRight: () => <SettingsButton/>
                });
            } else {
                // User not authenticated, use simple header
                navigation.setOptions({
                    headerLeft: () => null,
                    headerTitle: () => null,
                    headerRight: () => <SettingsButton/>
                });

            }
        }); // Cleanup subscription
    }, [navigation]);

    const handleTextChange = (text) => {
        // Reset inactivity timer when user types
        // scheduleInactivityReminder(3600);
        const cleanedText = text.replace(/\n/, "");
        setQueryText(cleanedText);
    };

    const fetchRandomInputs = async () => {
        try {
            const translationCollection = collection(db, "translation");
            const querySnapshot = await getDocs(translationCollection);
            const inputs = querySnapshot.docs.map((doc) => doc.data().englishInput);
            setRandomInputs(inputs.sort(() => 0.5 - Math.random()).slice(0, 5));
        } catch (error) {
            console.error("Error fetching random inputs: ", error);
        }
    };

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    };

    useEffect(() => {
        fetchRandomInputs();
    }, [])

    return (
        <ScrollView
            bg={colors.surface}
            flex={1}
            contentContainerStyle={{alignItems: "center"}}
        >
            <VStack space={4} alignItems="center" w="100%" mt={5}>

                {/* Random Words and Input Box */}
                <Box w="80%">
                    <QuickInputWords
                        label="Try:"
                        words={randomInputs}
                        onWordPress={setQueryText}
                    />
                    {/* Input */}
                    <Box position="relative" mt={3}>
                        <Input
                            variant="outline"
                            placeholder="Type English or Chinese..."
                            onChangeText={handleTextChange}
                            value={queryText}
                            multiline={true}
                            h={40}
                            paddingX={1}
                            paddingY={2}
                            style={{
                                fontSize: 20,
                                color: colors.onSurface,
                            }}
                        />
                        {queryText.length > 0 && (
                            <IconButton
                                icon={
                                    <Ionicons
                                        name="close-outline"
                                        size={30}
                                        color={colors.onSurfaceVariant}
                                    />
                                }
                                position="absolute"
                                top={0}
                                right={0}
                                _hover={{bg: "transparent"}}
                                _pressed={{bg: "transparent"}}
                                onPress={() => setQueryText("")}
                            />
                        )}
                    </Box>
                </Box>

                {/* Submit Button */}
                {queryText.length > 0 && (
                    <Box w="80%" flexDirection="row" justifyContent="flex-end">
                        <IconButton
                            icon={
                                <Ionicons
                                    name="checkbox"
                                    size={40}
                                    color={colors.onPrimaryContainer}
                                />
                            }
                            onPress={() =>
                                navigation.navigate("Result", {query: queryText})
                            }
                            _hover={{bg: "transparent"}}
                            _pressed={{bg: "transparent"}}
                        />
                    </Box>
                )}
            </VStack>
        </ScrollView>
    );
}
